export enum SweepAccountTypeEnum {
  Cheque = "20" ,
  Savings = "10"
}

export namespace SweepAccountTypeEnum {
  export function values() {
    return Object.keys(SweepAccountTypeEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}


